import React from 'react';
import { formatValue } from './formatters';
import { useAnimatedNumber } from './AnimatedValue';
import './ReportsNative.css';

/**
 * Tabular-numeral mono value. Null/undefined/NaN render "—".
 *
 * Props:
 *   value      number | string | null
 *   format     'currency'|'currency2'|'currencyCompact'|'number'|'number1'|
 *              'number2'|'numberCompact'|'percent'|'percent1'|'percent2'|
 *              'hours'|'text' | (value) => string        (default 'number')
 *   currency   ISO code for currency formats (default USD)
 *   muted      render in onyx-400
 *   size       font-size px override
 *   animate    tween value changes (count-up) — opt-in; leave off inside
 *              large tables where hundreds of cells would tween at once
 *   className, style, title
 */
export function MonoValue({ value, format = 'number', currency, muted = false, size, animate = false, className, style, title }) {
  const animated = useAnimatedNumber(animate ? value : null);
  const text = formatValue(animate && Number.isFinite(animated) ? animated : value, format, currency ? { currency } : undefined);
  return (
    <span
      className={`rn-mono${muted ? ' rn-muted' : ''}${className ? ` ${className}` : ''}`}
      style={size ? { fontSize: size, ...style } : style}
      title={title}
    >
      {text}
    </span>
  );
}

export default MonoValue;
